import { BodyStyles, CSSProperties, HeaderStyles } from '../../../../models';
import { Button } from '../../../forms/button/models';

export interface DropdownExpansionContent {
  button: Button;
  headerLink?: string;
}

export interface DropdownExpansionConfig {
  showHeader?: boolean;
}

export interface DropdownExpansionStyles {
  content?: CSSProperties;
  container?: CSSProperties;
  icon?: CSSProperties;
  body?: BodyStyles;
  header?: HeaderStyles;
  footer?: CSSProperties;
  background?: CSSProperties;
}
